const STRIPE_PUBLISHABLE_KEY_PATTERN = /^pk_(test|live)_/i

export const getStripePublishableKey = () => {
    const fromEnv = process.env.REACT_APP_STRIPE_PUBLIC_KEY || ''
    const storeConfiguration =
        global?.storeConfiguration || global?.storeConfigration || global?.storeDetails || {}

    const fromStoreConfig =
        storeConfiguration?.stripe_publishable_key?.value ||
        storeConfiguration?.public_key?.value ||
        ''

    const key = typeof fromEnv === 'string' && fromEnv.trim() ? fromEnv : fromStoreConfig
    if (typeof key !== 'string') {
        return ''
    }

    const trimmedKey = key.trim()
    return STRIPE_PUBLISHABLE_KEY_PATTERN.test(trimmedKey) ? trimmedKey : ''
}
